import styled from 'styled-components'
import ResultItem from 'components/Osearch/ResultItem'
import GoogleSearch from 'containers/Osearch/GoogleSearch'

const TryGoogleWrapper = styled.div`
  text-align: center;
  color: var(--dark-gray);
  margin-top: 10px;
`

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: #888;
  font-size: 18px;
  border-radius: 8px;
  margin: 32px 0;
`

const LoadingState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50px;
  color: #888;
  font-size: 18px;
  border-radius: 8px;
  margin: 32px 0;
`

const Results = ({ searchQuery, results, isLoading, onClick }) => {
  if (!isLoading && (!results || results.length === 0)) {
    return (
      <>
        <EmptyState>
          <span
            role="img"
            aria-label="No results"
            style={{ fontSize: 48, marginBottom: 16 }}
          >
            🔍
          </span>
          <div>No results found</div>
          <div style={{ fontSize: 14, color: '#bbb', marginTop: 8 }}>
            Try adjusting your search or filters.
          </div>
        </EmptyState>

        <TryGoogleWrapper>
          <GoogleSearch query={searchQuery} />
        </TryGoogleWrapper>
      </>
    )
  }

  return (
    <div>
      {results.map((item, i) => (
        <ResultItem key={`${item.title}-${i}`} item={item} onClick={onClick} />
      ))}
      {isLoading && (
        <LoadingState>
          <div>Loading results...</div>
        </LoadingState>
      )}
    </div>
  )
}

export default Results
